<template>
  <v-row
    class="pt-2"
    :style="{
      backgroundColor:
        pageOrigin === 'book' ? productSelected.collection_color : 'white',
    }"
  >
    <v-col cols="12" md="7">
      <label :class="['text-h6', pageOrigin === 'book' ? 'white--text' : '']"
        >Fornecedor: {{ productSelected.provider_code }} -
        {{ productSelected.provider_name }}</label
      >
      <v-divider></v-divider>
    </v-col>
    <v-col cols="12" md="5">
      <label class="text-h6 white--text">
        {{ pageOrigin === "book" ? productSelected.collection : "&nbsp;" }}
      </label>
      <v-divider></v-divider>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    productSelected: {},
    pageOrigin: {
      type: String,
      default: "book",
    },
  },
};
</script>
